module.exports = __webpack_public_path__ + "static/PS_Questions to Understand_HL-c01549ff34bef595f3549f79acaed85d.pdf";